import React from 'react';
import ReactDOM from 'react-dom';
import { ReactSVG } from "react-svg";
import { motion, AnimatePresence } from "framer-motion";
import i18n from '../../i18n/i18n.js';
import TypedLink from '../TypedLink/TypedLink.js';
import { Utils } from '../../Utils.js';
import ProductListItem from '../../components/ProductListItem/ProductListItem.js';
import { ModalsContext, withAppContext } from '../../contexts/AppContext';

import './Search.css';

class Search extends React.Component {

  static contextType = ModalsContext;

  emptyFormData = {
    term: '',
  };

  typeing_interval = null;

  constructor(props) {
      super(props);

      this.state = {
        show: false,
        show_results: false,
        formData: { ...this.emptyFormData },
        products:{},
        categories:{},
        keywords:{},
        searchListUrl:'',
        product_count:0
      }

      this.placeholder = props.placeholder ? props.placeholder.replace('&#039;', "'") : i18n.t('searchPlaceholder');
      
      this.appRef = this.props.appContext.appRef;
  }

  show() {
    this.setState({show: true});
  }

  hide() {
    const formData = this.state.formData;

    formData.term = '';

    this.setState({show: false, formData: formData, show_results: false});
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  show_results() {
    this.context.AppFooterMenuRef?.current?.hide_all_menu_item();
    this.setState({show_results: true});
  }

  hide_results() {
    this.setState({show_results: false});
  }

  handle_change(event, formDataKey, force_value = null) {
    
    if(this.typeing_interval){
      clearTimeout(this.typeing_interval);
    }

    const formData = this.state.formData;
    formData[formDataKey] = force_value !== null ? force_value : event.target.value;
    this.setState({formData});

    this.typeing_interval = setTimeout(()=>{
      this.get_search_data();
    },1000);

  }

  get_search_data(){

    if(this.state.formData.term && this.state.formData.term.length<=3){
      return false;
    }
    Utils.get_server_data('', { APICACHE:'false', search_keywords: this.state.formData.term }, { ajax_event: 'search_products', search_keywords: this.state.formData.term })
    .then((res)=>{
      this.setState({
        products:res.suggested_products,
        categories:res?.suggested_categories,
        searchListUrl:res?.search_list_url,
        keywords:res?.suggested_keywords,
        product_count: res?.suggested_products_count || 0
      },()=>this.show_results());
    });

  }

  render_search_input(formData,is_button_only = false){ 
    return <div className="search">
      <ReactSVG className="icon" src={`/assets/images/search.svg`} />
      <input 
        name='search_keywords' 
        onClick={is_button_only ? () => this.toggle() : undefined}  
        placeholder={this.placeholder} 
        type="text" 
        value={formData.term} 
        onChange={(e) => this.handle_change(e, 'term')} />
    </div>;
  }

  render_overlay_search_input(formData) {
    return <div className="search_overlay_input_cont">
        <input 
            name='search_keywords_overlay' 
            placeholder={this.placeholder} 
            type="text" 
            value={formData.term} 
            onChange={(e) => this.handle_change(e, 'term')} 
        />
        <ReactSVG className="icon" src={`/assets/images/search.svg`} />
    </div>;
  }

  render() {
    const { formData, show, show_results } = this.state;

    return <>
      {!show && this.render_search_input(formData, true)}
      
      {ReactDOM.createPortal(
      <AnimatePresence>
        {show && (
          <motion.div 
            className="search_overlay"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <div className="search_header">
               {this.render_overlay_search_input(formData)}
               <div className="close_btn" onClick={() => this.hide()}>
                  <ReactSVG src="/assets/images/close.svg" />
               </div>
            </div>

            <div className="search_body">
                {show_results ? <div className="search_results">
                  
                  {this.state?.categories.length > 0 ? 
                    <div className="search_results_block categories">
                      <label>{i18n.t('searchCategories')}</label>
                      <div className="items">
                        {this.state.categories && this.state.categories.map((category) => {
                          const categoriesPath = category.category.split('/');
                          const categoryName = categoriesPath.pop();
                          return (
                          <React.Fragment key={category.url}>
                            <TypedLink onClick={() => this.hide()} link={{type:'products', url: category.url, title: ''}}>
                              {categoriesPath.length > 0 && <span className='categories_path'>
                                {categoriesPath.map((catPart, index) => (
                                  <span key={index}>
                                    {catPart}
                                    {(index < categoriesPath.length - 1) ? ' / ' : ''}
                                  </span>
                                ))}
                              </span>}
                              <div className='cat_name'>
                                {categoryName}
                              </div>
                            </TypedLink>
                          </React.Fragment>
                          );
                        })}
                      </div>
                    </div>
                  : ''}

                  {Object.keys(this.state.keywords).length>0 ?
                    <div className='search_results_block keywords'>
                      <label>{i18n.t('searchKeywords')}</label>
                      <div className="items">
                        {this.state.keywords && Object.keys(this.state.keywords).map((keyword) => (
                          <div key={keyword} className="keyword_item" onClick={() => this.handle_change(null, 'term', Utils.htmlDecode(keyword))}>
                            {Utils.htmlDecode(keyword)}
                          </div>
                        ))}
                      </div>
                    </div> 
                  : ''}
                    
                  <div className="search_results_block products">
                    <label>{i18n.t('searchProducts')}</label>
                    <div className="items">
                      <div className='product-list-items-cont'>
                        {this.state.products?.products && this.state.products?.products?.length>0 ? this.state.products?.products.map(product => <ProductListItem key={`${product.id}`} thumbSize="thumb_small_" product={product} parentFunction={() => this.hide()} />) : <span className='no-results'>{i18n.t('searchNoresult')}</span>}    
                      </div>
                    </div>
                    {this.state.searchListUrl && this.state.products?.products?.length > 0 ?
                      <div className='search_page_url'>
                        <TypedLink onClick={() => this.hide()} link={{type:'products', url: this.state.searchListUrl, title: i18n.t('searchAllItemsURL',{count: this.state.product_count})}}></TypedLink>
                      </div> 
                    : ''}
                  </div>

                </div> : <div className="type_for_search">{i18n.t('typeForSearch')}</div>}
            </div>
          </motion.div>
        )}
      </AnimatePresence>, document.getElementById('portal-root'))}
    </>;
  }
}

export default withAppContext(Search);

